import { fadeColor, getColor, styled } from "imaginarity-react-ui";

export class ContentComparisonSliderSC {
    public static ContentComparisonSliderContainer = styled.div<{ orientation: "vertical" | "horizontal", isLoaded: boolean, allowPointerEvents: boolean; }>`
        position: relative;
        width: 100%;
        cursor: ${p => p.orientation};
        user-select: ${p => p.allowPointerEvents ? "all" : "none"};
        overflow: hidden;
        visibility: ${p => p.isLoaded ? 'visible' : 'hidden'};
`;
    public static ContainerBottom = styled.div<{ allowPointerEvents: boolean }>`
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        pointer-events: ${p => p.allowPointerEvents ? "all" : "none"};
        user-select: ${p => (p.allowPointerEvents ? 'none' : 'auto')}; /* Verhindert Markieren */
        z-index: 1;
`;
    public static ContainerTop = styled.div<{ orientation: 'vertical' | 'horizontal'; sliderPosition: number; isAnimating: boolean; animationDuration: string; allowPointerEvents: boolean; }>`
        position: absolute;
        top: 0;
        left: 0;
        clip-path: ${p => p.orientation === 'vertical' ? `inset(0 0 0 ${p.sliderPosition}%)` : `inset(0 0 ${100 - p.sliderPosition}% 0)`};
        width: 100%;
        height: 100%;
        z-index: 2;
        pointer-events: ${p => p.allowPointerEvents ? "all" : "none"};
        user-select: ${p => (p.allowPointerEvents ? 'none' : 'auto')}; /* Verhindert Markieren */
        transition: ${p => (p.isAnimating ? `clip-path ${p.animationDuration} ease-in-out` : 'none')};
`;

    public static InfoText = styled.div<{ infoTextColor?: string, infoTextColorShadow?: string }>`
        position: absolute;
        top: 10px;
        right: 10px;
        color: ${p => getColor(p, p.infoTextColor ?? "@accentBlack")};
        z-index: 10;
        pointer-events: none;
        font-size: 1.2em;
        text-shadow: ${p => `1px 1px 2px ${p.infoTextColorShadow ?? "#000"}`};
`;

    public static ContextMenu = styled.div`
        position: fixed;
        background: ${p => getColor(p, "@mainBackground")};
        box-shadow: 0 6px 8px -6px #000;
        z-index: 2147483637;
        border-radius: 0px;
        overflow: hidden;
        display: grid;
        grid-template-columns: 40px 1fr;
        border: 1px solid ${p => getColor(p, "@middleLightGrey")};
`;

    public static ContextMenuItem = styled.div`
        display: flex;
        align-items: center;
        justify-content: center;
        user-select: none;
`;
    public static ContextMenuItemCancel = styled.div`
        border-bottom: 1px solid ${p => getColor(p, "@middleLightGrey")};
        display: flex;
        align-items: center;
        justify-content: center;
`;


    // SLIDER

    public static SliderLine = styled.div<{ top: string, left: string, width: string, height: string, locked: boolean }>`
        position: absolute;
        top: ${p => p.top};
        left: ${p => p.left};
        width: ${p => p.width};
        height: ${p => p.height};
        background-color: ${p => getColor(p, p.locked ? "@accent" : "background")};
        pointer-events: none;
        box-shadow: 0 0 80px 2px #000;
        z-index: 3;
`;
    public static SliderButton = styled.div<{ top: string, left: string, locked: boolean }>`
        position: absolute;
        top: ${p => p.top};
        left: ${p => p.left};
        width: 40px;
        height: 40px;
        background-color: ${p => fadeColor(p, p.locked ? "@accent" : "@accentBlack", p.locked ? 80 : 30)};
        border: 1px solid ${p => getColor(p, p.locked ? "@accent" : "background")};
        transform: translate(-50%, -50%);
        //pointer-events: ${p => p.locked ? "all" : "none"};
        pointer-events: none;
        z-index: 4;
        border-radius: 20px;
        text-align: center;
        box-shadow: 0 0 26px -3px ${p => getColor(p, "@darkGrey")};
`;

    public static SliderButtonArrow = styled.div<{ pos: "left" | "right", sliderIsVertical: boolean }>`
        width: 0;
        height: 0;
        border-top: 7px solid transparent;
        border-bottom: 7px solid transparent;
        ${p => p.pos === "right" ? `border-right: 7px solid ${fadeColor(p, "@mainBackground", 100)};` : ""}
        ${p => p.pos === "left" ? `border-left: 7px solid ${fadeColor(p, "@mainBackground", 100)};` : ""}
        pointer-events: none;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: rotate(${p => (p.sliderIsVertical ? 180 : 90)}deg) 
                translate(${p => {
            if (p.sliderIsVertical) {
                return p.pos === "right" ? '-4px, 50%' : '11px, 50%';
            } else {
                return p.pos === "right" ? '-15px, 3px' : '1px, 3px';
            }
        }});
`;
    public static SliderButtonIcon = styled.div`
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);        
        pointer-events: all;
        cursor: pointer;
        svg{
            stroke-width: 2.5;
        }
`;


}